<!-- 大转盘 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="handleOpenDrawer"
                >
                    新增大转盘活动
                </Button>

                <Table :columns="tableColumns" :data="tableData" border>
                    <template slot-scope="{ row }" slot="records_count">
                        <Button @click="handleOpenCountDrawer(row)">{{
                            row.records_count
                        }}</Button>
                    </template>

                    <template slot-scope="{ row }" slot="status">
                        <div class="flex-c">
                            <i-switch
                                v-model="row.status"
                                size="large"
                                true-color="#FF761D"
                                :true-value="1"
                                :false-value="0"
                                @on-change="handleChangeStatus(row)"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>

                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                type="primary"
                                ghost
                                @click="handleOpenDrawer(row)"
                                >编辑</Button
                            >
                            <Button
                                type="error"
                                ghost
                                @click="handleDelete(row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>

            <div class="page-container">
                <Page
                    :current="queryParams.page"
                    :page-size="queryParams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="handlePageChange"
                />
            </div>
        </div>

        <!-- 新增/编辑弹窗 -->
        <Drawer v-model="drawerVisible" width="80">
            <div slot="header">{{ drawerTitle }}</div>
            <div slot="close"></div>

            <Menu
                class="mb24"
                mode="horizontal"
                :active-name="editTab"
                @on-select="handleSwitchTab"
            >
                <MenuItem name="1" class="mr24">基础设置</MenuItem>
                <MenuItem name="2">奖品设置</MenuItem>
            </Menu>

            <div class="drawer-container">
                <!-- 左侧转盘预览 -->
                <div class="luckywheel-container">
                    <div class="header-bg">
                        <div class="title">{{ formData.title }}</div>
                        <div class="subtitle">{{ formData.copy_text }}</div>
                    </div>

                    <div class="wheel-container">
                        <div class="wheel-bg">
                            <div class="wheel">
                                <div
                                    class="wheel-bg-item"
                                    v-for="(item, index) in prizeForm.prizes"
                                    :key="`bg-${index}`"
                                    :style="getWheelBgStyle(index)"
                                ></div>

                                <div
                                    class="wheel-content-item"
                                    v-for="(item, index) in prizeForm.prizes"
                                    :key="`content-${index}`"
                                    :style="getWheelContentStyle(index)"
                                >
                                    <img
                                        class="prize-icon"
                                        :src="item.show_image_url"
                                        alt="奖品图标"
                                    />
                                    <span class="prize-name">{{
                                        item.name
                                    }}</span>
                                </div>
                            </div>

                            <img
                                src="@/assets/luckywheel/wheelbg.png"
                                class="wheel-border"
                                alt=""
                            />
                            <img
                                src="@/assets/luckywheel/pointer.png"
                                class="pointer"
                                alt=""
                            />
                        </div>
                    </div>

                    <div class="time-info">
                        <span
                            v-if="
                                formData.show_date &&
                                formData.start_time &&
                                formData.end_time
                            "
                        >
                            抽奖时间：{{ formData.start_time }} ~
                            {{ formData.end_time }}
                        </span>
                    </div>

                    <div class="btn-group">
                        <div class="btn btn-blue">剩余抽奖1次</div>
                        <div class="btn btn-orange">查看中奖记录</div>
                    </div>

                    <div v-if="formData.rule_title" class="text-box">
                        <span class="text-content">{{
                            formData.rule_title
                        }}</span>
                    </div>

                    <div class="desc-box">
                        <div v-if="formData.rule_desc" class="desc-item">
                            {{ formData.rule_desc }}
                        </div>
                    </div>
                </div>

                <!-- 右侧表单区域 - 基础设置 -->
                <Form
                    v-if="editTab === '1'"
                    style="width: 100%"
                    :model="formData"
                    label-position="right"
                    :label-width="150"
                >
                    <div class="form-title">产品设置</div>
                    <FormItem label="产品批次：">
                        <Select
                            v-model="formData.batch_id"
                            class="w300"
                            clearable
                            filterable
                            placeholder="请选择产品批次"
                        >
                            <Option
                                v-for="item in batchList"
                                :key="item.id"
                                :value="item.id"
                                >{{ item.batch_name }}</Option
                            >
                        </Select>
                    </FormItem>

                    <FormItem label="产品名称：">
                        <Select
                            v-model="formData.product_id"
                            class="w300"
                            clearable
                            filterable
                            placeholder="请选择产品名称"
                        >
                            <Option
                                v-for="item in productList"
                                :key="item.id"
                                :value="item.id"
                                >{{ item.product_name }}</Option
                            >
                        </Select>
                    </FormItem>

                    <FormItem label="产品代理商：">
                        <Select
                            v-model="formData.agent_id"
                            class="w300"
                            clearable
                            filterable
                            placeholder="请选择产品代理商"
                        >
                            <Option
                                v-for="item in agentList"
                                :key="item.id"
                                :value="item.id"
                                >{{ item.agent_name }}</Option
                            >
                        </Select>
                    </FormItem>

                    <div class="form-title">活动详情</div>
                    <FormItem label="活动名称：">
                        <Input
                            v-model="formData.name"
                            class="w300"
                            placeholder="请输入活动名称"
                        />
                    </FormItem>

                    <FormItem label="中奖概率：">
                        <Input
                            v-model="formData.global_probability"
                            class="w300"
                            placeholder="请输入中奖概率"
                        >
                            <span slot="prepend">万分之</span>
                        </Input>
                    </FormItem>

                    <FormItem label="中奖概率模式：">
                        <RadioGroup v-model="formData.draw_mode">
                            <Radio label="1" class="mr24">按库存比例</Radio>
                            <Radio label="2">自定义中奖比例</Radio>
                        </RadioGroup>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="cursor-p ml24"
                                type="md-help-circle"
                                size="20"
                                color="#FF4838"
                            />
                            <div slot="content">
                                <p>中奖概率非100%时，至少有一个谢谢惠顾</p>
                            </div>
                        </Tooltip>
                    </FormItem>

                    <FormItem label="抽奖时间：">
                        <div class="dis-flex-c">
                            <DatePicker
                                class="w120"
                                :value="formData.start_time"
                                type="date"
                                placeholder="请选择"
                                @on-change="handleStartTimeChange"
                            />
                            <div class="ml24 mr24">至</div>
                            <DatePicker
                                class="w120 mr24"
                                :value="formData.end_time"
                                type="date"
                                placeholder="请选择"
                                @on-change="handleEndTimeChange"
                            />
                            <i-switch
                                v-model="formData.show_date"
                                size="large"
                                true-color="#FF761D"
                                :true-value="1"
                                :false-value="0"
                            >
                                <span slot="open">显示</span>
                                <span slot="close">不显示</span>
                            </i-switch>
                        </div>
                    </FormItem>

                    <FormItem label="抽奖规则：">
                        <RadioGroup v-model="formData.times_limit_type">
                            <Radio label="0" class="mr24">每天一次</Radio>
                            <Radio label="1">一码一次</Radio>
                        </RadioGroup>
                    </FormItem>

                    <div class="form-title">文案设置</div>
                    <FormItem label="标题名称：">
                        <Input
                            v-model="formData.title"
                            class="w300"
                            placeholder="请输入标题名称 限制8字"
                            maxlength="8"
                        />
                    </FormItem>

                    <FormItem label="文案一：">
                        <Input
                            v-model="formData.copy_text"
                            class="w300"
                            placeholder="请输入文案一"
                        />
                    </FormItem>

                    <div class="form-title">规则说明</div>
                    <FormItem label="规则标题：">
                        <Input
                            v-model="formData.rule_title"
                            class="w300"
                            placeholder="请输入规则标题"
                        />
                    </FormItem>

                    <FormItem label="规则说明：">
                        <Input
                            type="textarea"
                            v-model="formData.rule_desc"
                            class="w400"
                            placeholder="请输入规则说明"
                            :rows="4"
                        />
                        <!-- <editor
                            class="w444"
                            :edtor-con="formData.rule_desc"
                            :index="2"
                            @getContent="handleEditorContent2"
                            @getContentchange="handleEditorContent2"
                        /> -->
                    </FormItem>
                </Form>

                <!-- 奖品配置 -->
                <div v-else class="prize-container">
                    <div class="prize-left">
                        <div
                            v-for="(item, index) in prizeForm.prizes"
                            :key="index"
                            :class="
                                selectedPrizeIndex === index
                                    ? 'prize-item-active'
                                    : 'prize-item'
                            "
                            @click="selectedPrizeIndex = index"
                        >
                            <img
                                src="@/assets/del.png"
                                alt="删除"
                                class="prize-del"
                                @click.stop.prevent="handleDeletePrize(index)"
                            />
                            奖品{{ index + 1 }}
                        </div>

                        <div class="prize-item-btn" @click="handleAddPrize">
                            <Icon type="md-add" class="mr6" />新增奖品
                        </div>
                    </div>

                    <Form
                        v-if="currentPrize"
                        :model="currentPrize"
                        label-position="right"
                        :label-width="100"
                    >
                        <FormItem label="奖品选择：">
                            <RadioGroup
                                v-model="currentPrize.type"
                                @on-change="handleChangePrizeType"
                            >
                                <Radio :label="4" class="mr24">谢谢参与</Radio>
                                <Radio :label="2" class="mr24">微信红包</Radio>
                                <Radio :label="3" class="mr24">积分</Radio>
                                <Radio :label="1">商品</Radio>
                            </RadioGroup>
                        </FormItem>

                        <FormItem label="上传图片：">
                            <div
                                class="form-upload"
                                @click="handleOpenImageModal"
                            >
                                <img
                                    class="wh100"
                                    v-if="currentPrize.show_image_url"
                                    :src="currentPrize.show_image_url"
                                    alt="奖品图"
                                />
                                <Icon
                                    v-else
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                            </div>
                        </FormItem>

                        <!-- 谢谢参与 -->
                        <template v-if="currentPrize.type === 4">
                            <FormItem label="奖品名称：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.name"
                                    placeholder="请输入奖品名称"
                                />
                            </FormItem>
                        </template>

                        <!-- 微信红包 -->
                        <template v-if="currentPrize.type === 2">
                            <FormItem label="奖品名称：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.name"
                                    placeholder="请输入奖品名称"
                                />
                            </FormItem>
                            <FormItem label="红包金额：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.money"
                                    type="number"
                                    placeholder="请输入红包金额"
                                />
                            </FormItem>
                            <FormItem label="红包库存：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.total_stock"
                                    type="number"
                                    placeholder="请输入红包库存"
                                />
                            </FormItem>
                            <FormItem
                                v-if="formData.draw_mode == 2"
                                label="中奖比例："
                            >
                                <InputNumber
                                    class="w300"
                                    v-model="currentPrize.probability"
                                    :min="0"
                                    placeholder="请输入中奖比例"
                                />
                            </FormItem>
                        </template>

                        <!-- 积分 -->
                        <template v-if="currentPrize.type === 3">
                            <FormItem label="名称：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.name"
                                    placeholder="请输入名称"
                                />
                            </FormItem>
                            <FormItem label="积分数量：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.points"
                                    type="number"
                                    placeholder="请输入积分数量"
                                />
                            </FormItem>
                            <FormItem label="库存：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.total_stock"
                                    type="number"
                                    placeholder="请输入库存"
                                />
                            </FormItem>
                            <FormItem
                                v-if="formData.draw_mode == 2"
                                label="中奖比例："
                            >
                                <InputNumber
                                    class="w300"
                                    v-model="currentPrize.probability"
                                    :min="0"
                                    placeholder="请输入中奖比例"
                                />
                            </FormItem>
                        </template>

                        <!-- 商品 -->
                        <template v-if="currentPrize.type === 1">
                            <FormItem label="发放方式：">
                                <RadioGroup
                                    v-model="currentPrize.distribution_type"
                                    @on-change="handleChangeDistributionType"
                                >
                                    <Radio :label="2" class="mr24">线上发货</Radio>
                                    <Radio :label="1">到店核销</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem label="商品名称：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.name"
                                    placeholder="请输入商品名称"
                                />
                            </FormItem>
                            <FormItem label="选择商品：">
                                <Select
                                    class="w300"
                                    v-model="currentPrize.goods_id"
                                    clearable
                                    filterable
                                    placeholder="请选择商品"
                                >
                                    <Option
                                        v-for="item in productList"
                                        :key="item.id"
                                        :value="item.id"
                                        >{{ item.product_name }}</Option
                                    >
                                </Select>
                            </FormItem>
                            <FormItem label="商品库存：">
                                <Input
                                    class="w300"
                                    v-model="currentPrize.total_stock"
                                    type="number"
                                    placeholder="请输入商品库存"
                                />
                            </FormItem>
                            <FormItem
                                v-if="formData.draw_mode == 2"
                                label="中奖比例："
                            >
                                <InputNumber
                                    class="w300"
                                    v-model="currentPrize.probability"
                                    :min="0"
                                    placeholder="请输入中奖比例"
                                />
                            </FormItem>
                        </template>
                    </Form>

                    <div v-else class="pl20">请在左侧选中奖品进行编辑</div>
                </div>
            </div>

            <div class="drawer-footer">
                <Button @click="handleCloseDrawer">取消</Button>
                <Button
                    class="theme-bc ml24 theme-default-color"
                    @click="handleSubmitDrawer"
                    :loading="submitLoading"
                >
                    {{ editTab === "1" ? "下一步" : "确定" }}
                </Button>
            </div>
        </Drawer>

        <!-- 参与人数弹窗 -->
        <Drawer v-model="countDrawerVisible" title="参与人数" width="80">
            <div>
                <div class="flex-sb mb24">
                    <div>
                        <Input
                            class="w200 mr24"
                            v-model="countQuery.name"
                            placeholder="请输入人员名称"
                        />
                        <Select
                            class="w200 mr24"
                            v-model="countQuery.status"
                            clearable
                            filterable
                            placeholder="请选择发放状态"
                        >
                            <Option
                                v-for="item in status_list"
                                :key="item.id"
                                :value="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                        <DatePicker
                            class="w200"
                            type="daterange"
                            split-panels
                            placeholder="请选择时间段"
                            @on-change="handleDateChange"
                        />
                    </div>
                    <Button
                        class="theme-bc theme-default-color"
                        icon="ios-search"
                        @click="handleSearchRecord"
                    >
                        确认搜索
                    </Button>
                </div>

                <Table :columns="recordColumns" :data="recordData" border>
                    <template slot-scope="{ row }" slot="customer">
                        {{ row.customer ? row.customer.name : "" }}
                    </template>
                    <template slot-scope="{ row }" slot="prize">
                        {{ row.prize ? row.prize.name : "" }}
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <!-- <Button type="success" ghost>重新发放</Button> -->
                        <template v-if="row.prize && row.prize.type == 1">
                            <Button
                                v-if="row.status == 0"
                                type="primary"
                                ghost
                                @click="handleOpenDeliveryModal(row)"
                                >配送</Button
                            >
                            <Button
                                v-else-if="row.status == 1"
                                @click="goDeliveryInfo(row)"
                                >已发货</Button
                            >
                        </template>
                    </template>
                </Table>

                <div class="page-drawer">
                    <Page
                        :current="countQuery.page"
                        :page-size="countQuery.limit"
                        :total="recordTotal"
                        show-elevator
                        show-total
                        @on-change="handleRecordPageChange"
                    />
                </div>
            </div>
        </Drawer>

        <!-- 配送弹窗 -->
        <Modal
            v-model="deliveryModalVisible"
            title="配送信息"
            width="600"
            :mask-closable="false"
        >
            <Form
                :model="deliveryForm"
                label-position="right"
                :label-width="100"
            >
                <FormItem label="配送信息：" class="mt24">
                    <Input
                        type="textarea"
                        v-model="deliveryForm.delivery_info"
                        :rows="3"
                    />
                </FormItem>
                <FormItem label="备注：">
                    <editor
                        :edtor-con="deliveryForm.prize_info"
                        :index="1"
                        @getContent="handleEditorContent"
                        @getContentchange="handleEditorContent"
                    />
                </FormItem>
            </Form>

            <div slot="footer">
                <Button @click="deliveryModalVisible = false">取消</Button>
                <Button
                    class="theme-bc ml24 theme-default-color"
                    @click="handleSubmitDelivery"
                >
                    确定
                </Button>
            </div>
        </Modal>

        <!-- 配送信息 -->
        <Modal
            v-model="deliveryModalInfo"
            title="配送信息"
            width="600"
            :mask-closable="false"
        >
            <div>
                <div class="dis-flex">
                    <div class="delivery-title">收货人：</div>
                    <div>{{ delivery_data.name }}</div>
                </div>
                <div class="dis-flex">
                    <div class="delivery-title">联系方式：</div>
                    <div>{{ delivery_data.phone }}</div>
                </div>
                <div class="dis-flex mb24">
                    <div class="delivery-title">收货地址：</div>
                    <div>{{ delivery_data.address }}</div>
                </div>
                <div class="dis-flex">
                    <div class="delivery-title">配送信息：</div>
                    <div>{{ delivery_data.delivery_info }}</div>
                </div>
                <div class="dis-flex">
                    <div class="delivery-title">发货时间：</div>
                    <div>{{ delivery_data.created_at }}</div>
                </div>
                <div class="dis-flex">
                    <div class="delivery-title">备注：</div>
                    <div
                        class="ql-editor"
                        v-html="delivery_data.prize_info"
                    ></div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>

        <!-- 图片选择组件 -->
        <pictureLibrary
            v-if="imageModalVisible"
            :switch_modal.sync="imageModalVisible"
            :select="selectType"
            @change="handleImageSelect"
        />
    </div>
</template>

<script>
import {
    lottery_activity_index,
    lottery_activity_save,
    lottery_activity_toggle,
    lottery_activity_delete,
    lottery_activity_detail,
    product_select,
    batch_select,
    agent_select,
    lottery_prize_save,
    lottery_record_index,
    lottery_record_update_delivery,
} from "@/api/index";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";

// 奖品默认配置：key=type值
const PRIZE_DEFAULT_MAP = {
    4: {
        name: "谢谢参与",
        img: "icon/prizes/4.png",
    },
    2: {
        name: "微信红包",
        img: "icon/prizes/3.png",
    },
    3: {
        name: "积分",
        img: "icon/prizes/2.png",
    },
    1: {
        name: "商品",
        img: "icon/prizes/1.png",
    },
};

export default {
    name: "LotteryActivity",
    components: { pictureLibrary, editor },
    data() {
        return {
            // 图片选择器
            selectType: 1,
            imageModalVisible: false,

            // 列表查询
            queryParams: { page: 1, limit: 10 },
            total: 0,
            tableData: [],

            // 表格列配置（抽离，便于维护）
            tableColumns: [
                { type: "index", width: 60, align: "center" },
                { title: "活动名称", key: "name", align: "center" },
                { title: "参与人数", slot: "records_count", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],

            // 新增/编辑抽屉
            drawerVisible: false,
            drawerTitle: "",
            editTab: "1", // 1-基础设置 2-奖品设置
            submitLoading: false, // 防重复提交

            // 活动基础表单
            formData: {
                id: "",
                name: "",
                start_time: "",
                end_time: "",
                product_id: "",
                batch_id: "",
                agent_id: "",
                times_limit_type: "1",
                global_probability: "",
                draw_mode: "1",
                title: "",
                copy_text: "",
                rule_title: "",
                rule_desc: "",
                show_date: 1,
            },

            // 奖品表单
            prizeForm: { activity_id: "", prizes: [] },
            selectedPrizeIndex: -1,

            // 下拉数据
            batchList: [],
            productList: [],
            agentList: [],
            status_list: [
                { id: 0, name: "待发放" },
                { id: 1, name: "已发放" },
                { id: 2, name: "发放失败" },
            ],
            // 参与记录弹窗
            countDrawerVisible: false,
            countQuery: {
                activity_id: "",
                page: 1,
                limit: 10,
                name: "",
                status: "",
                start_date: "",
                end_date: "",
            },
            recordData: [],
            recordTotal: 0,
            recordColumns: [
                { type: "index", width: 60, align: "center" },
                { title: "人员名称", slot: "customer", align: "center" },
                { title: "奖品", slot: "prize", align: "center" },
                { title: "领取时间", key: "created_at", align: "center" },
                { title: "发放状态", key: "show_status_text", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "100px",
                },
            ],

            // 配送弹窗
            deliveryModalVisible: false,
            deliveryForm: {
                record_id: "",
                delivery_info: "",
                prize_info: "",
            },
            deliveryModalInfo: false,
            delivery_data: {},
        };
    },

    computed: {
        /**
         * 当前选中的奖品（直接操作原对象，无副本）
         */
        currentPrize() {
            const { prizes } = this.prizeForm;
            if (this.selectedPrizeIndex < 0 || !prizes.length) return null;
            const prize = prizes[this.selectedPrizeIndex];
            const defaultConf = PRIZE_DEFAULT_MAP[prize.type];

            if (defaultConf) {
                // 没有预览图，预览+原图一起赋值默认
                if (!prize.show_image_url) {
                    prize.show_image_url =
                        this.config.apiUrl + "/" + defaultConf.img;
                    prize.image_url = defaultConf.img; // 默认图时image_url和预览同源
                }
                // 没有名称补默认名
                if (!prize.name) {
                    prize.name = defaultConf.name;
                }
            }
            return prize;
        },
    },

    mounted() {
        this.initPage();
    },

    methods: {
        // ========================== 初始化 ==========================
        async initPage() {
            this.getActivityList();
            this.getProductList();
            this.getBatchList();
            this.getAgentList();
        },

        // ========================== 列表接口 ==========================
        async getActivityList() {
            try {
                const res = await lottery_activity_index(this.queryParams);
                this.tableData = res.data.data || [];
                this.total = res.data.total || 0;

                // 空数据自动回退页码
                if (this.tableData.length === 0 && this.queryParams.page > 1) {
                    this.queryParams.page--;
                    this.getActivityList();
                }
            } catch (err) {
                this.$Message.error(err.msg || "获取活动列表失败");
            }
        },

        // ========================== 下拉选项 ==========================
        async getProductList() {
            try {
                const res = await product_select();
                this.productList = res.data || [];
            } catch (err) {
                this.$Message.error(err.msg || "获取产品列表失败");
            }
        },
        async getBatchList() {
            try {
                const res = await batch_select();
                this.batchList = res.data || [];
            } catch (err) {
                this.$Message.error(err.msg || "获取批次失败");
            }
        },
        async getAgentList() {
            try {
                const res = await agent_select();
                this.agentList = res.data || [];
            } catch (err) {
                this.$Message.error(err.msg || "获取代理商失败");
            }
        },

        // ========================== 转盘样式 ==========================
        getWheelBgStyle(index) {
            const { prizes } = this.prizeForm;
            const total = prizes.length;
            if (!total) return {};

            const color1 = "#f3efc5";
            const color2 = "#d01b17";
            const color3 = "#ffd39f";

            let bgColor;
            // 单数 && 最后一项：使用第三色
            if (total % 2 === 1 && index === total - 1) {
                bgColor = color3;
            } else {
                bgColor = index % 2 === 0 ? color1 : color2;
            }

            if (this.prizeForm.prizes.length == 2) {
                const deg = 360 / total;
                return {
                    background: bgColor,
                    position: "absolute",
                    width: "50%",
                    height: "100%",
                    left: "50%",
                    top: 0,
                    transformOrigin: "left bottom",
                    transform: `rotate(${index * deg}deg) skewY(${0}deg)`,
                };
            } else {
                const deg = 360 / total;
                return {
                    marginTop: "-20px",
                    background: bgColor,
                    position: "absolute",
                    width: "50%",
                    height: "calc(50% + 20px)",
                    left: "50%",
                    top: 0,
                    transformOrigin: "left bottom",
                    transform: `rotate(${index * deg}deg) skewY(${
                        deg - 90
                    }deg)`,
                };
            }
        },

        getWheelContentStyle(index) {
            const { prizes } = this.prizeForm;
            const total = prizes.length;
            if (!total) return {};

            const singleDeg = 360 / total;
            const midDeg = index * singleDeg + singleDeg / 2;
            const radius = 90;
            const rad = (midDeg * Math.PI) / 180;
            const x = Math.sin(rad) * radius;
            const y = -Math.cos(rad) * radius;
            const colorArr = ["#d01b17", "#f3efc5"];

            if (this.prizeForm.prizes.length == 1) {
                return {
                    color: "#f3efc5",
                    left: `calc(50% + ${x}px)`,
                    top: `calc(50% + ${y}px)`,
                    transform: "translate(-50%,-50%)",
                };
            } else {
                return {
                    color: colorArr[index % 2],
                    left: `calc(50% + ${x}px)`,
                    top: `calc(50% + ${y}px)`,
                    transform: "translate(-50%,-50%)",
                };
            }
        },

        // ========================== 抽屉操作 ==========================
        /**
         * 打开新增/编辑抽屉
         */
        async handleOpenDrawer(row = null) {
            this.editTab = "1";
            this.resetForm();

            if (row?.id) {
                this.drawerTitle = "编辑大转盘活动";
                await this.getActivityDetail(row.id);
            } else {
                this.drawerTitle = "新增大转盘活动";
            }

            // 延迟打开，解决渲染闪烁
            setTimeout(() => {
                this.drawerVisible = true;
            }, 200);
        },

        handleCloseDrawer() {
            this.drawerVisible = false;
        },

        handleSwitchTab(name) {
            this.editTab = name;
        },

        // ========================== 表单操作 ==========================
        resetForm() {
            this.formData = {
                id: "",
                name: "",
                start_time: "",
                end_time: "",
                product_id: "",
                batch_id: "",
                agent_id: "",
                times_limit_type: "1",
                global_probability: "",
                draw_mode: "1",
                title: "幸运大转盘",
                copy_text: "天天抽奖转不停",
                rule_title: "活动内容",
                rule_desc:
                    "一、参与方式：扫码即可参与\n二、兑换方式：红包积分直接到账，实物商品快递或现场领取\n三：中奖记录明细在个人中心，查看",
                show_date: 1,
            };
            this.prizeForm = {
                activity_id: "",
                prizes: [
                    {
                        name: "谢谢参与",
                        type: 4,
                        image_url: "icon/prizes/4.png",
                        show_image_url:
                            "https://test.suyuan02.hulianzaowu.work/icon/prizes/4.png",
                    },
                ],
            };
            this.selectedPrizeIndex = -1;
        },

        async getActivityDetail(id) {
            try {
                const res = await lottery_activity_detail({ id });
                const data = res.data || {};

                this.formData = {
                    ...this.formData,
                    ...data,
                    times_limit_type: (data.times_limit_type || 0).toString(),
                    draw_mode: (data.draw_mode ?? 1).toString(),
                };

                this.prizeForm.activity_id = data.id;
                this.prizeForm.prizes = data.prizes || [];
                this.selectedPrizeIndex = this.prizeForm.prizes.length ? 0 : -1;
            } catch (err) {
                this.$Message.error(err.msg || "获取详情失败");
            }
        },

        handleStartTimeChange(val) {
            this.formData.start_time = val || "";
        },
        handleEndTimeChange(val) {
            this.formData.end_time = val || "";
        },

        // ========================== 奖品操作 ==========================
        handleAddPrize() {
            const initConf = PRIZE_DEFAULT_MAP[4];
            const newPrize = {
                name: initConf.name,
                type: 4,
                image_url: initConf.img, // 原图
                show_image_url: this.config.apiUrl + "/" + initConf.img, //预览图
                total_stock: "",
                probability: "",
                sort_order: 0,
                money: "",
                points: "",
                goods_id: "",
            };
            this.prizeForm.prizes.push(newPrize);
            this.selectedPrizeIndex = this.prizeForm.prizes.length - 1;
        },

        handleDeletePrize(index) {
            this.prizeForm.prizes.splice(index, 1);
            this.selectedPrizeIndex = -1;
        },

        // ========================== 图片选择 ==========================
        handleOpenImageModal() {
            if (!this.currentPrize) {
                return this.$Message.warning("请先选中奖品");
            }
            this.imageModalVisible = true;
        },

        handleImageSelect(urlArr, realUrlArr) {
            if (!this.currentPrize) return;
            this.currentPrize.show_image_url = urlArr[0] || "";
            this.currentPrize.image_url = realUrlArr[0] || "";
        },

        // ========================== 提交保存 ==========================
        async handleSubmitDrawer() {
            if (this.submitLoading) return;
            this.submitLoading = true;

            try {
                if (this.editTab === "1") {
                    // 保存基础信息
                    const res = await lottery_activity_save(this.formData);
                    this.prizeForm.activity_id = res.data.id;
                    this.$Message.success("基础信息保存成功");
                    this.editTab = "2";
                } else {
                    // 保存奖品
                    if (!this.prizeForm.activity_id) {
                        return this.$Message.warning("请先完成基础设置");
                    }
                    if (this.prizeForm.prizes.length === 0) {
                        return this.$Message.warning("请至少添加一个奖品");
                    }

                    await lottery_prize_save(this.prizeForm);
                    this.$Message.success("保存成功");
                    this.drawerVisible = false;
                    this.getActivityList();
                }
            } catch (err) {
                this.$Message.error(err.msg || "保存失败");
            } finally {
                this.submitLoading = false;
            }
        },

        // ========================== 状态/删除 ==========================
        async handleChangeStatus(row) {
            this.$Modal.confirm({
                title: "确认",
                content: "确定要切换活动状态吗？",
                onOk: async () => {
                    try {
                        await lottery_activity_toggle({ id: row.id });
                        this.$Message.success("状态切换成功");
                        this.getActivityList();
                    } catch (err) {
                        this.$Message.error(err.msg || "切换失败");
                        row.status = row.status === 1 ? 0 : 1; // 回显
                    }
                },
                onCancel: () => {
                    row.status = row.status === 1 ? 0 : 1; // 取消则回显
                },
            });
        },

        handleDelete(row) {
            this.$Modal.confirm({
                title: "删除确认",
                content: "删除后无法恢复，确定继续吗？",
                onOk: async () => {
                    try {
                        await lottery_activity_delete({ id: row.id });
                        this.$Message.success("删除成功");
                        this.getActivityList();
                    } catch (err) {
                        this.$Message.error(err.msg || "删除失败");
                    }
                },
            });
        },

        // ========================== 参与记录 ==========================
        async getRecordList() {
            try {
                const res = await lottery_record_index(this.countQuery);
                this.recordData = res.data.data || [];
                this.recordTotal = res.data.total || 0;
            } catch (err) {
                this.$Message.error(err.msg || "获取记录失败");
            }
        },

        handleOpenCountDrawer(row) {
            this.countQuery.activity_id = row.id;
            this.getRecordList();
            this.countDrawerVisible = true;
        },

        handleSearchRecord() {
            this.countQuery.page = 1;
            this.getRecordList();
        },

        // ========================== 配送 ==========================
        handleOpenDeliveryModal(row) {
            this.deliveryForm.record_id = row.id;
            this.deliveryModalVisible = true;
        },

        goDeliveryInfo(row) {
            this.delivery_data = row;
            this.deliveryModalInfo = true;
        },

        async handleSubmitDelivery() {
            try {
                await lottery_record_update_delivery(this.deliveryForm);
                this.$Message.success("配送信息保存成功");
                this.deliveryModalVisible = false;
                this.getRecordList();
            } catch (err) {
                this.$Message.error(err.msg || "保存失败");
            }
        },

        handleEditorContent(data) {
            this.deliveryForm.prize_info = data.editorData || "";
        },
        // handleEditorContent2(data) {
        //     this.formData.rule_desc = data.editorData || "";
        // },

        // ========================== 分页 ==========================
        handlePageChange(page) {
            this.queryParams.page = page;
            this.getActivityList();
        },

        handleRecordPageChange(page) {
            this.countQuery.page = page;
            this.getRecordList();
        },

        // 预留空方法
        handleDateChange(e) {
            if (e[0]) {
                this.countQuery.start_date = e[0];
                this.countQuery.end_date = e[1];
            } else {
                this.countQuery.start_date = "";
                this.countQuery.end_date = "";
            }
        },

        handleChangePrizeType(type) {
            if (!this.currentPrize) return;
            const conf = PRIZE_DEFAULT_MAP[type];
            if (!conf) return;
            this.currentPrize.name = conf.name;
            // 切换类型，预览图+入库图都赋值默认
            this.currentPrize.show_image_url =
                this.config.apiUrl + "/" + conf.img;
            this.currentPrize.image_url = conf.img;
        },
        handleChangeDistributionType(type) {
            if (!this.currentPrize) return;
            this.currentPrize.distribution_type = type;
        },
    },
};
</script>

<style scoped>
.w120 {
    width: 120px;
}
.w300 {
    width: 300px;
}
.w400 {
    width: 400px;
}

.container {
    display: flex;
    flex-direction: column;
}

.form-title {
    margin-bottom: 24px;
    color: #484e66;
    font-weight: 600;
}

.content {
    padding: 24px;
    background: #fff;
    box-shadow: 0 0 4px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}

.page-container {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}

.drawer-container {
    display: flex;
    height: calc(100% - 180px);
    overflow: auto;
}

.drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 24px;
    text-align: right;
    background: #fff;
}

.form-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed #9fa5bb;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.wh100 {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: contain;
}

.dis-flex-c {
    display: flex;
    align-items: center;
}

.dis-flex {
    display: flex;
}

.page-drawer {
    margin-top: 24px;
    text-align: right;
}

.luckywheel-container {
    margin-right: 48px;
    min-width: 375px;
    width: 375px;
    max-width: 375px;
    min-height: 900px;
    overflow-y: auto;
    background: url("../../assets/luckywheel/bg.png");
    background-size: cover;
    padding: 24px 0;
    border-radius: 8px;
}

.prize-container {
    min-width: 600px;
    width: 600px;
    max-width: 600px;
    min-height: 656px;
    height: auto;
    display: flex;
    border: 1px solid #747b95;
}

.prize-left {
    margin-right: 24px;
    min-width: 111px;
    width: 111px;
    max-width: 111px;
}

.prize-item-active,
.prize-item {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #747b95;
    cursor: pointer;
    font-size: 15px;
    position: relative;
    background: #fff;
}

.prize-item {
    border-right: 1px solid #747b95;
}

.prize-item-active {
    border-right: 1px solid #fff;
    color: #ff761d;
    font-weight: bold;
}

.prize-item-btn {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #fe761d;
    font-size: 15px;
    color: #fff;
}

.prize-del {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.mr6 {
    margin-right: 6px;
}

.header-bg {
    padding: 20px 0;
    text-align: center;
    color: #faeed2;
}

.title {
    font-size: 36px;
    font-weight: bold;
}

.subtitle {
    font-size: 18px;
    margin-top: 10px;
}

.wheel-container {
    display: flex;
    justify-content: center;
    margin: 20px 0;
    position: relative;
    z-index: 1;
}

.wheel-bg {
    position: relative;
    width: 300px;
    height: 300px;
}

.wheel-border {
    position: absolute;
    width: 300px;
    left: 0;
    top: 0;
    z-index: 1;
}

.wheel {
    position: absolute;
    width: 250px;
    height: 250px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    background-color: #d01b17;
}

.wheel-bg-item {
    position: absolute;
    width: 50%;
    height: 50%;
    left: 50%;
    top: 0;
    transform-origin: left bottom;
}

.wheel-content-item {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 3;
}

.prize-icon {
    width: 26px;
    height: 26px;
    object-fit: contain;
}

.prize-name {
    font-size: 12px;
    margin-top: 4px;
    white-space: nowrap;
}

.pointer {
    position: absolute;
    width: 88px;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    z-index: 5;
}

.time-info {
    text-align: center;
    color: #bd552a;
    font-size: 14px;
    margin: 80px 0 20px;
    position: relative;
    z-index: 2;
}

.btn-group {
    display: flex;
    justify-content: space-between;
    margin: 0 auto 30px;
    position: relative;
    z-index: 2;
    width: 80%;
}

.btn {
    width: 45%;
    height: 36px;
    border-radius: 20px;
    font-size: 14px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
}

.btn-blue {
    background: linear-gradient(#4a90e2, #357abd);
}

.btn-orange {
    background: linear-gradient(#f79747, #f37a1f);
}

.text-box {
    max-width: 80%;
    width: fit-content;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e02a2a;
    border: 2px solid #fff;
    border-radius: 8px;
    position: relative;
    z-index: 2;
    padding: 3px 15px;
}

.text-content {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}

.desc-box {
    color: #333;
    background: #fff9e6;
    width: 80%;
    margin: 0 auto;
    padding: 12px;
    border-radius: 10px;
    border: 2px solid #e02a2a;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
}

.desc-item {
    font-size: 13px;
    /* 长英文自动换行 */
    white-space: pre-line;
    word-wrap: break-word;
}

.cursor-p {
    cursor: pointer;
}

.delivery-title {
    min-width: 100px;
    width: 100px;
    max-width: 100px;
    text-align: right;
}
.w444 {
    width: 444px;
}

::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    color: #ff761d;
    border-bottom: 2px solid #ff761d;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border: 2px solid #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #fff;
}
::v-deep .ivu-checkbox {
    background-color: #fff;
}
::v-deep .ql-editor {
    padding: 0px !important;
    width: 444px !important;
}
::v-deep .ql-editor img {
    width: 100% !important;
}
</style>